import React from 'react';
import { StyleSheet } from 'react-native';

import { LeagueNavigator } from '@/components/league-navigator/components/LeagueNavigator';
import { LeagueNavigatorSkeleton } from '@/components/league-navigator/components/LeagueNavigatorSkeleton';
import { LEAGUE_NAVIGATOR_HEIGHT } from '@/components/league-navigator/utils/league-navigator-utils';
import { Box } from '@/components/lib/components';

import { useNavigationLaunchpad } from '../../hooks/use-navigation-launchpad';

export const NavigationLaunchpad = () => {
    const { items, isLoading, selectedId, onSelect, onViewAllPress } = useNavigationLaunchpad();

    return (
        <Box style={styles.container}>
            {isLoading ? (
                <LeagueNavigatorSkeleton />
            ) : (
                <LeagueNavigator
                    leagues={items}
                    selectedId={selectedId}
                    onSelectLeague={onSelect}
                    onViewAllPress={onViewAllPress}
                />
            )}
        </Box>
    );
};

const styles = StyleSheet.create({
    container: {
        height: LEAGUE_NAVIGATOR_HEIGHT,
        overflow: 'hidden',
    },
});
